export var AudioScope;

(function (AudioScope) {
  AudioScope["Section"] = "section";
  AudioScope["Question"] = "question";
})(AudioScope || (AudioScope = {}));